"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultUserProfilesDir = getDefaultUserProfilesDir;
exports.getDefaultUserProfilesFile = getDefaultUserProfilesFile;
exports.getDefaultUsername = getDefaultUsername;
exports.parseUserProfiles = parseUserProfiles;
exports.loadUserProfiles = loadUserProfiles;
exports.loadUserProfile = loadUserProfile;
const path = __importStar(require("path"));
const os = __importStar(require("os"));
const logging_1 = require("./logging");
const errors_1 = require("@mytmpvpn/mytmpvpn-common/errors");
function getDefaultUserProfilesDir() {
    return path.join(os.homedir(), '.config', 'mytmpvpn');
}
function getDefaultUserProfilesFile() {
    return path.join(getDefaultUserProfilesDir(), 'mytmpvpn.json');
}
function getDefaultUsername() {
    const userNameFromEnv = process.env['MYTMPVPN_USERPROFILE_NAME'];
    if (userNameFromEnv != null && userNameFromEnv !== undefined && userNameFromEnv.trim() !== '') {
        return userNameFromEnv;
    }
    return 'default';
}
function parseUserProfiles(content) {
    return JSON.parse(content);
}
function loadUserProfiles(userProfilesFile) {
    try {
        logging_1.logger.debug(`Loading user profiles from: ${userProfilesFile}`);
        // Dynamic require to avoid breaking browser bundles
        const fs = require('fs');
        const content = fs.readFileSync(userProfilesFile, 'utf-8');
        return parseUserProfiles(content);
    }
    catch (err) {
        throw new errors_1.MyTmpVpnError(`Can't find user profile: ${userProfilesFile} -- caused by: ${err instanceof Error ? err.message : JSON.stringify(err)}`);
    }
}
function loadUserProfile(userProfilesFile, profileName) {
    const userProfiles = loadUserProfiles(userProfilesFile);
    const profileNameKey = profileName;
    logging_1.logger.debug(`Loading user profile ${profileName} from ${JSON.stringify(userProfiles)}`);
    const userProfile = userProfiles.profiles[profileNameKey];
    if (userProfile == null) {
        throw new errors_1.MyTmpVpnError(`Can't find configuration for ${profileName} in ${userProfilesFile}`);
    }
    return userProfile;
}
